<template>
  <strong :class="[`${situacaoClass}--text`, 'upperCase']">
    <slot>{{ situacao }}</slot>
  </strong>
</template>

<script>
  import moment from 'moment'

  export default {
    props: ['data', 'realizada', 'tipo'],
    computed: {
      situacao: {
        get: function () {
          if (this.realizada) {
            return 'Tarefa Realizada'
          } else {
            if (moment().isAfter(this.data, 'day')) {
              return 'Tarefa Atrasada'
            } else {
              return 'Tarefa Agendada'
            }
          }
        },
        set: function () {}
      },
      situacaoClass: {
        get: function () {
          if (this.realizada) {
            this.situacao = 'Tarefa Realizada'
            return 'primary'
          } else {
            if (moment().isAfter(this.data, 'day')) {
              this.situacao = 'Tarefa Atrasada'
              return 'grey'
            } else {
              this.situacao = 'Tarefa Agendada'
              return 'grey'
            }
          }
        },
        set: function () {}
      }
    }
  }
</script>

<style scoped>
  .upperCase { text-transform: uppercase; }
</style>



// WEBPACK FOOTER //
// TarefasSituacao.vue?647f8702